import { memo, useCallback, useState } from 'react';

import { OBJECTION_WARNING_BLOCK_ID } from 'KnmPmPackage/MainModule/constants/knmPmFieldsElementsIds';
import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';

import { IKnmFormRef } from '../../../KnmPackage/MainModule/interfaces/IKnmFormRef';

interface IPmObjectionWarningProps {
  attachmentsNumber: number;
  className?: string;
  formRef: IKnmFormRef | undefined;
  isWatchOnly: boolean;
}

export const PmObjectionWarning = memo(
  ({ attachmentsNumber, className = '', formRef, isWatchOnly }: IPmObjectionWarningProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <div className={className} id={OBJECTION_WARNING_BLOCK_ID}>
        <div className="shared-group-label">
          Сведения о направлении возражения на&nbsp;
          <span className="shared-no-wrap-text">
            предостережение
            <Button
              className="shared-btn-add"
              text="Добавить"
              variant="link"
              color="primary"
              type="button"
              id="pmObjectionWarningAddButton"
              disabled={isWatchOnly || attachmentsNumber > 0}
              onClick={openSignModal}
            />
          </span>
        </div>

        <KnmAttachmentsSigning
          isWatchOnly={isWatchOnly}
          name="objectionWarningAttachments"
          isVisibleSignModal={isVisibleSignModal}
          closeSignModal={closeSignModal}
          formRef={formRef}
        />
      </div>
    );
  },
);
